<template>
  <div :class="['row full-width justify-center', isMobile ? 'q-pt-md q-pb-lg' : 'q-px-sm q-py-lg']">
    <div :class="['column col-11', isMobile ? 'q-gutter-y-md' : 'q-gutter-y-lg']">

      <!-- header -->
      <div
        :class="['row full-width border-radius border-solid bg-white justify-around text-grey-4', isMobile ? 'q-pa-lg' : 'q-py-lg']"
        :style="{height: isMobile ? undefined : '370px'}">

        <!-- image -->
        <q-img v-if="!isMobile" class="col-4" src="img/faq.png" height="100%" fit="contain"/>

        <!-- title, search questions -->
        <div :class="['row col-12 col-md-4 items-center', isMobile ? 'q-gutter-y-lg' : 'q-gutter-y-xl']">

          <!-- title -->
          <div class="col-12 self-end">

            <!-- mobile -->
            <div v-if="isMobile" class="text-h5 text-bold text-primary text-center">
              سوالات متداول
            </div>

            <!-- desktop -->
            <h1 v-else class="no-margin text-bold text-primary">
              سوالات متداول
            </h1>

          </div>

          <!-- search questions -->
          <div :class="['row col-12 items-center self-start', isMobile ? 'justify-center' : '']">

            <!-- search field -->
            <div :class="['col-12 col-md border-radius bg-white q-px-md text-grey-4', isMobile ? '' : '']"
                 style="border: 2px solid">
              <q-input v-model="searchInput" label="دنبال چی میگردی؟" color="white" bg-color="white"
                       label-color="grey-8" borderless dense @update:model-value="search"/>
            </div>

          </div>

        </div>

      </div>

      <!-- questions -->
      <q-expansion-item v-for="question of (searchInput === null || searchInput === '' ? faq : results)"
                        class="border-radius bg-white text-subtitle1 text-weight-light"
                        style="border: 1px solid lightgrey"
                        header-class="border-radius" icon="la la-pen-nib"
                        group="expansion" :label="question.question">
        <div class="row full-width q-pa-md">
          <div class="text-subtitle2 text-weight-light text-justify text-grey-8" style="line-height: 30px">
            {{ question.answer }}
          </div>
        </div>
      </q-expansion-item>

    </div>
  </div>
</template>

<script>
import {useMeta} from "quasar";

export default {
  async preFetch({store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath}) {
    if (ssrContext) {
      await store.dispatch('getMeta', {pageUrl: ssrContext.req.headers.host + currentRoute.path})
    } else {
      await store.dispatch('getMeta', {pageUrl: window.location.host + currentRoute.path})
    }
    await store.dispatch('loadFaq')

    let meta = {}
    meta.title = store.state.preFetch.pageMeta.metaTitle
    meta.description = store.state.preFetch.pageMeta.metaDescription
    meta.keywords = store.state.preFetch.pageMeta.metaKeywords

    let faq = store.state.preFetch.faq
    let faqSchema = []
    for (const item of faq) {
      faqSchema.push(
        {
          "@context":"http://schema.org",
          "@type": "Question",
          "name": item.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": item.answer
          }
        }
      );
    }
    meta.script = {
      ldJson: {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [ faqSchema ]
          }
        )
      },
    }
    return await store.dispatch('setMeta', meta)
  },
  name: "FAQ",
  data: () => ({
    searchInput: null,
    results: []
  }),
  computed: {
    isMobile() {
      return this.$q.screen.lt.md
    },
    faq(){
      return this.$store.state.preFetch.faq
    }
  },
  methods: {
    search() {
      this.results = this.faq.filter(x => x.question.includes(this.searchInput) || x.answer.includes(this.searchInput))
    }
  },
  mounted() {
    useMeta(this.$store.state.meta)
    this.$store.commit('setPageLoadState', true)
  }
}
</script>

<style scoped>
h1 {
  font-size: 60px !important;
  line-height: 54px;
}
</style>
